import React, { useRef, useEffect, useCallback, useContext } from 'react';
import { Context } from "..";

export default function useDesignerMessage(callback, type) {

    const refCallback = useRef();
    const context = useContext(Context);

    useEffect(() => {
        refCallback.current = callback;
    }, [callback]);

    const sCallback = useCallback((data) => {
        refCallback.current?.(data);
    }, []);

    useEffect(() => {

        if (!context)
            return;

        context.eventEmitter.on(type, sCallback);

        return () => {
            context.eventEmitter.off(type, sCallback);
        }

    }, [context?.eventEmitter, type, sCallback]);
}